var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-component pcStyle"},[_c('img',{attrs:{"src":require("@/assets/images/autelLogo.png"),"alt":""}}),_c('div',{staticClass:"border-bottom"})])
}]

export { render, staticRenderFns }